module.exports = __webpack_public_path__ + "static/media/recent-entry-timer.b04292b9.svg";